






















































import {
  computed,
  defineComponent, onMounted, reactive, ref,
} from '@vue/composition-api';
import { useFormat, useRouter } from '@ideavivat/vivat-2';

import {
  getJob,
} from '@/api/index';
import { defaultCustomer } from '@/types/customer';

import CommonIconTop from '@/components/CommonIconTop.vue';
import PanelWithBasicJobInfo from '@/components/Job/PanelWithBasicJobInfo.vue';
import PanelWithBudgetSummary from '@/components/Job/PanelWithBudgetSummary.vue';
import PanelWithSubJobTable from '@/components/Job/PanelWithSubJobTable.vue';
import PanelWithExpenseDetail from '@/components/Job/PanelWithExpenseDetail.vue';
import useAuth from '@/use/useAuth';

const defaultJobStats = {
  done: 0,
  total: 0,
  inProgress: 0,
  overdue: 0,
  costs: 0,
  totalCosts: 0,
  totalExpenses: 0,
  totalDiscount: 0,
};

const Detail = defineComponent({
  components: {
    CommonIconTop,
    PanelWithBasicJobInfo,
    PanelWithBudgetSummary,
    PanelWithSubJobTable,
    PanelWithExpenseDetail,
  },
  setup(props, { root }) {
    const { route } = useRouter();
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const toDateTime = (date: string): string => useFormat.date(date).displayFullThaiDateTime();
    const viewExpense = ref(false);
    const job = reactive({
      name: '',
      code: '',
      quotation: '',
      reporterName: '',
      machineName: '',
      machineCode: '',
      processName: '',
      jobStats: defaultJobStats,
      customer: defaultCustomer,
      customer_po: '',
      targetDate: '',
      createdAt: '',
      updatedAt: '',
      deletedAt: '',
      is_assembly: 1,
      status: 'PENDING',
    });
    const computedJob = computed(() => job);

    async function callGetJob() {
      const jobData = (await getJob(route.value.params.id)).data;
      job.name = jobData.name;
      job.code = jobData.code;
      job.quotation = jobData.quotation;
      job.reporterName = jobData.reporter_name;
      job.machineName = jobData.machine_name;
      job.createdAt = jobData.created_at;
      job.jobStats = jobData.bom_stats || defaultJobStats;
      job.targetDate = jobData.target_date;
      job.customer = jobData.customer || defaultCustomer;
      job.customer_po = jobData.customer_po || '';

      job.createdAt = jobData.created_at;
      job.updatedAt = jobData.updated_at;
      job.deletedAt = jobData.deleted_at;

      job.is_assembly = jobData.is_assembly;
      job.status = jobData.status;
      // costs: [{id: 1, bom_id: 1, category: "STD", name: "STD-ME", cost: "1200.00", created_at: null,…},…]
    }

    onMounted(async () => {
      await callGetJob();
    });

    return {
      hasPermission,
      toDateTime,
      viewExpense,
      job: computedJob,
      callGetJob,
    };
  },
});

export default Detail;
